@if (this.contact) {
  <div
    [hidden]="formMode != formModes.View"
    class="flex-container"
    style="justify-items: start; gap: 12px"
  >
    <div>
      <div style="font-weight: bold; margin-bottom: 5px">
        {{ this.contact.contactTypes.join(', ') }}
      </div>
      <div style="margin-bottom: 5px">
        {{ this.contact.firstName }} {{ this.contact.lastName }}<br />
      </div>
      <div style="margin-bottom: 5px">
        {{ this.contact.emailAddress }}
      </div>
      @if (this.contact.phone) {
        <div style="margin-bottom: 5px">
          Phone:
          <a href="tel:+1{{ this.contact.phone }}">{{
            uiHelpers.formatPhone(this.contact.phone, 'US')
          }}</a>
          <a style="padding-left: 4px" href="tel:+1{{ this.contact.phone }}"
            ><app-icon
              [type]="IconType.Phone"
              [class]="'xxsmall'"
              [title]="'Launch phone call'"
            ></app-icon
          ></a>
        </div>
      }
      @if (this.contact.fax) {
        <div style="margin-bottom: 5px">
          Fax: {{ uiHelpers.formatPhone(this.contact.fax, 'US') }}
        </div>
      }
    </div>
    <!-- <div style="vertical-align: middle;" [hidden]="readonly">
    <button class="iconButton" (click)="btnEdit_click()"><i class="fa-regular fa-pen-to-square icon" ></i> Edit</button>
  </div> -->
  </div>
}

<div [hidden]="formMode != formModes.Edit">
  <div style="justify-content: space-between; gap: 20px; padding: 10px 0px">
    <!-- <div style="flex:1; padding-right:20px; border-right:1px solid #dddddd;"> -->
    <div class="formRow" style="margin-bottom: 20px">
      @for (contactType of ALL_CONTACT_TYPES; track contactType) {
        <div>
          <input
            type="checkbox"
            [value]="contactType.id"
            [(ngModel)]="selectedContactTypes[contactType.id]"
          />
          {{ contactType.id }}
        </div>
      }
      <!-- <app-ddl-input [label]="'Contact Type'" [helpText]="'Only select \'Primary\' if this person can be contacted for all account concerns.'" [readonly]="false" [required]="true" [options]="contactTypeOptions" [(ngModel)]="this.editableContact.contactType"></app-ddl-input> -->
    </div>
    <div class="formRow">
      <app-text-input
        [label]="'First Name'"
        [readonly]="false"
        [required]="true"
        [(ngModel)]="this.editableContact.firstName"
      ></app-text-input>
      <app-text-input
        [label]="'Last Name'"
        [readonly]="false"
        [required]="true"
        [(ngModel)]="this.editableContact.lastName"
      ></app-text-input>
    </div>
    <div class="formRow">
      <app-text-input
        [label]="'Email Address'"
        [readonly]="false"
        [type]="inputTextModes.Email"
        [required]="true"
        [(ngModel)]="this.editableContact.emailAddress"
      ></app-text-input>
    </div>
    <div class="formRow">
      <app-text-input
        [label]="'Phone'"
        [readonly]="false"
        [required]="false"
        [type]="inputTextModes.Phone"
        [(ngModel)]="this.editableContact.phone"
      ></app-text-input>
      <app-text-input
        [label]="'Fax'"
        [readonly]="false"
        [required]="false"
        [type]="inputTextModes.Phone"
        [(ngModel)]="editableContact.fax"
      ></app-text-input>
    </div>
    <!-- </div>
  <div style="flex:1;">
    <app-street-address [addressLabel]="''" [readonly]="false" [required]="false" [(ngModel)]="editableContact.streetAddress"></app-street-address>
  </div> -->
  </div>

  <div style="text-align: center; margin-top: 15px">
    <input
      type="button"
      class="button_secondary button_var_2 button_right-spacing"
      (click)="btnSave_click()"
      value="Save"
      (keydown.enter)="btnSave_click()"
    />
    <input
      type="button"
      class="button_secondary button_var_2 button_right-spacing"
      (click)="btnDelete_click()"
      value="Delete"
      [hidden]="!editableContact.userId || editableContact.userId == ''"
    />
    <input
      type="button"
      class="button_secondary button_var_2"
      (click)="btnCancel_click()"
      value="Cancel"
      (keydown.escape)="btnCancel_click()"
    />
  </div>
</div>
